
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PlusCircle } from "lucide-react";

interface NewDreamFormProps {
  onAddDream: (dreamTitle: string) => Promise<void>;
}

const NewDreamForm: React.FC<NewDreamFormProps> = ({ onAddDream }) => {
  const [newDream, setNewDream] = useState('');
  
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!newDream.trim()) return;
    
    await onAddDream(newDream);
    setNewDream('');
  };

  return (
    <form onSubmit={handleSubmit} className="flex gap-2">
      <Input 
        placeholder="Add a new dream..." 
        value={newDream}
        onChange={(e) => setNewDream(e.target.value)}
        className="max-w-xs"
      />
      <Button type="submit" size="sm">
        <PlusCircle className="mr-2 h-4 w-4" />
        Add
      </Button>
    </form>
  );
};

export default NewDreamForm;
